import type { ThemeConfig } from 'antd';

import { tokens } from './tokens';

export const antTheme: ThemeConfig = {
  token: {
    colorPrimary: tokens.color.primary,
    colorSuccess: tokens.color.success,
    colorError: tokens.color.error,
    colorWarning: tokens.color.warning,
    colorInfo: tokens.color.info,
    colorBgLayout: tokens.color.surfacePage,
    colorText: tokens.color.text,
    colorTextSecondary: tokens.color.textSecondary,
    colorBorder: tokens.color.border,
    borderRadius: tokens.radius.sm,
    fontFamily: tokens.font.family,
  },
  components: {
    Button: {
      dangerColor: tokens.color.error,
      primaryShadow: 'none',
    },
    Input: {
      colorBgContainerDisabled: tokens.color.surfacePage,
      colorTextDisabled: tokens.color.text,
    },
    Select: {
      colorBgContainerDisabled: tokens.color.surfacePage,
      colorTextDisabled: tokens.color.text,
    },
    Message: {
      contentBg: tokens.color.surfaceCard,
      borderRadius: tokens.radius.md,
    },
  },
};
